module.exports = __webpack_public_path__ + "img/icon_edit.c648fd33.svg";